
export const formatDateWithOrdinal = (dateStr, includeTime = true) => {
  if (!dateStr) return "No Expiry";
  const date = new Date(dateStr);

  const day = date.getUTCDate();

  // const day = date.getDate();
  const getOrdinal = (n) => {
    const j = n % 10, k = n % 100;
    if (j === 1 && k !== 11) return "st";
    if (j === 2 && k !== 12) return "nd";
    if (j === 3 && k !== 13) return "rd";
    return "th";
  };

  const dayWithSuffix = `${day}${getOrdinal(day)}`;
  const monthYear = date.toLocaleString("en-IN", {
    month: "short",
    year: "numeric"
  });

  const time = date.toLocaleString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });

  return includeTime ? `${dayWithSuffix} ${monthYear}, ${time}` : `${dayWithSuffix} ${monthYear}`;
};

// export const formatExpiryDate = (dateString) => {
//   const date = new Date(dateString);

//   // Set seconds and milliseconds to zero
//   date.setSeconds(0, 0);

//   // Format to ISO string with timezone offset
//   const tzOffset = -date.getTimezoneOffset(); // in minutes
//   const sign = tzOffset >= 0 ? "+" : "-";
//   const pad = (num) => String(Math.floor(Math.abs(num))).padStart(2, "0");

//   const hours = pad(tzOffset / 60);
//   const minutes = pad(tzOffset % 60);

//   return (
//     date.toISOString().slice(0, 19) + sign + hours + ":" + minutes
//   );
// }

export const formatExpiryDate = (dateString) => {
  const date = new Date(dateString);

  // Keep everything same but set seconds and ms to 0
  // date.setSeconds(0, 0);
  date.setMilliseconds(0);

  // Convert back to ISO string with local timezone offset
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  // Get timezone offset
  const tzOffset = -date.getTimezoneOffset(); // in minutes
  const sign = tzOffset >= 0 ? "+" : "-";
  const tzHours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, "0");
  const tzMinutes = String(Math.abs(tzOffset) % 60).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${tzHours}:${tzMinutes}`;
};
